import React, { useState, useEffect } from 'react';
import cardUtils from '../../utils/cardUtils';
import shoppingCart from '../../utils/shoppingCart';
import formatter from '../../utils/formatter';

const TotalAmount = props => {
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    setTotalAmount(
      props.cards
        .map(card => cardUtils.sortPrices(card.cardPrices)[0])
        .reduce(
          (prev, curr) =>
            curr
              ? prev +
                (curr.currency === 'USD'
                  ? curr.price *
                    shoppingCart
                      .getStores()
                      .find(store => store.store === curr.store).exchangeRate
                  : curr.price)
              : prev + 0,
          0,
        ),
    );
  }, [props.cards]);

  return (
    <>
      {props.cards && (
        <div className="flex justify-between items-center bg-mediumColor p-3.5 rounded-md font-bold">
          <span className="text-lg text-white">
            Total de cartas: {props.cards.length}
          </span>
          <span className="text-lg text-white font-bold">
            Monto total: {formatter.formatNumber(totalAmount)} ARS
          </span>
        </div>
      )}
    </>
  );
};

export default TotalAmount;
